import env from '../../../env';
import { BaseComponent } from 'components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';

import { Dropdown } from '../../../components/Dropdown';
import _ from 'lodash';

import { deleteVehicleProperty, setVehicleProperties, setVehicleProperty } from '../actions';

import { AppClientId } from '../../Shared/constants';
import { getVehicleStatusLabel } from '../helpers';
import cn from 'classnames';
import ButtonComponent from '../../../containers/App/Components/Button/Button';
import styles from './CardStatus.module.css';

const STATE = {
  edit: false,
  status_remark: '',
};
/* eslint-disable react/prefer-stateless-function */
class VehicleStatusCardComp extends BaseComponent {
  constructor(props) {
    super(props, {
      ...STATE,
    });
  }

  componentDidMount() {
    if (this.props.setStatusLogs && this.props.vehicle?.status_remark) {
      this.setState({ status_remark: this.props.vehicle?.status_remark });
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.setStatusLogs) {
      this.state.edit !== prevState.edit && this.setState({ status_remark: this.props.vehicle?.status_remark });
    }
  }

  get options() {
    let statusesQuantity = [0, 1, 2, 3, 4];

    if (env.clientId === AppClientId.HILTERMANN) {
      statusesQuantity = [0, 1, 2, 3, 4, 7, 8, 9];
      if (env.vehicle_status_6) {
        statusesQuantity.push(6);
      }
    }

    return statusesQuantity.map(value => ({ label: getVehicleStatusLabel(value, this.lbl), value: `${value}` }));
  }

  get selected() {
    return this.options.find(o => o.value == this.state.selected);
  }

  get isReadOnlyStatuses() {
    return this.props.vehicle?.status == '5' || this.props.vehicle?.status == '6';
  }

  onChange(v) {
    this.setState({ selected: v.value });
  }

  save() {
    this.setState({ loading: true });
    if (this.props.setStatusLogs) {
      this.props.onChangeWithLogs(this.state.selected, this.props.loggedInUserId, this.state.status_remark, result => {
        this.setState({ loading: false, status_remark: '', edit: false });
      });
      return;
    }
    this.props.onChange(this.state.selected, result => {
      debugger;
      this.setState({ loading: false, edit: false });
    });
  }
  toggleEdit = () => {
    this.setState(prevState => ({ edit: !prevState.edit }));
  };

  componentDidUpdate(prevProps, prevState) {
    if (prevState.selected !== this.state.selected && this.state.selected !== this.props.vehicle?.state) {
      this.setState({ edit: true });
    }
  }

  render() {
    const currentStatus = this.selected?.value || this.props.vehicle?.status || this.props.status || '0';
    const dropdownClass = cn({
      [styles.dropdown]: true,
      [styles.dropdownStatus0]: currentStatus === '0',
      [styles.dropdownStatus1]: currentStatus === '1',
      [styles.dropdownStatus2]: currentStatus === '2',
      [styles.dropdownStatus3]: currentStatus === '3',
      [styles.dropdownStatus4]: currentStatus === '4',
      [styles.dropdownStatus5]: currentStatus === '5',
      [styles.dropdownStatus6]: currentStatus === '6',
      [styles.dropdownStatus7]: currentStatus === '7',
      [styles.dropdownStatus8]: currentStatus === '8',
      [styles.dropdownStatus9]: currentStatus === '9',
    });
    return (
      <div className={styles.dropdownBox}>
        <div className={styles.container}>
          <Dropdown
            className={dropdownClass}
            options={this.options}
            value={this.selected}
            onChange={this.onChange.bind(this)}
            placeholder={getVehicleStatusLabel(this.props.vehicle?.status, this.lbl, this.props.vehicle)}
            disabled={AppClientId.HOOIKAMMER == env.clientId || this.props.disableStatusChange}
          />
        </div>

        {this.state.edit && !this.isReadOnlyStatuses && this.state.selected != this.props.vehicle.state && (
          <>
            <div className="mt-2 mb-2">
              <label className="form-label">Status remark</label>
              <input
                className="form-control"
                value={this.state.status_remark}
                onChange={e => this.setState({ status_remark: e.target.value })}
              />
            </div>

            <ButtonComponent size={'btn-sm'} style={'ButtonSoftEdit'} onClick={() => this.save()}>
              {this.lbl('save')}
            </ButtonComponent>
          </>
        )}
      </div>
    );
  }
}

VehicleStatusCardComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) => createStructuredSelector({});

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    onChange(status, callback) {
      dispatch(setVehicleProperty(ownProps.vehicle.id, 'status', status, callback));
    },
    removeStatusInfo(vehicleId, propertyName, callback) {
      dispatch(deleteVehicleProperty(vehicleId, propertyName, callback));
    },
    onChangeWithLogs(status, user, info = '', callback) {
      let props = info
        ? ['user_changed_status', user, 'status', status, 'status_remark', info]
        : ['user_changed_status', user, 'status', status, 'status_remark', ' '];
      dispatch(
        setVehicleProperties(
          ownProps.vehicle.id,
          _.chunk(props, 2).map(pair => ({
            propertyName: pair[0],
            propertyValue: pair[1],
          })),
          callback,
        ),
      );
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const VehicleStatusCard = compose(withConnect, withRouter)(VehicleStatusCardComp);
